/* jshint esversion: 6 */
import React from 'react';
import InputEditorWrapper from 'app/mixins/InputEditorWrapper.jsx';
import InputBehaviorComponent from 'app/components/EditorComponents/InputBehaviorComponent.jsx';
import TwitterInputConfigPanel from 'app/components/EditorComponents/TwitterInputConfigPanel.jsx';
import InstagramConfigPanel from 'app/components/EditorComponents/InstagramConfigPanel.jsx';
import PinterestConfigPanel from 'app/components/EditorComponents/PinterestConfigPanel.jsx';
import FacebookPageConfigPanel from 'app/components/EditorComponents/FacebookPageConfigPanel.jsx';
import TikTokInputConfigPanel from 'app/components/EditorComponents/TikTokInputConfigPanel.jsx';
import YouTubeInputConfigPanel from 'app/components/EditorComponents/YouTubeInputConfigPanel.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import EchoComponent from 'app/components/EditorComponents/EchoComponent.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import CreateSubtypePanel from 'app/components/EditorComponents/CreateSubtypePanel.jsx';

class FeedConfigurePanel extends React.Component {
    render() {
        let constants = this.props.app.config.constants,
            ConfigPanel = null,
            inputName = (this.props.input !== undefined && this.props.input !== null && this.props.input.name) ? this.props.input.name : '',
            replay = null;

        if (!this.props.isFreeUser()) {
            replay = (
                <EchoComponent {...this.props}/>
            );
        }

        // tailor the panel on the input type
        if (this.props.input.type == constants.INPUT_TYPE_FEED) {
            if (this.props.input.subtype) {
                let subtypeConfig = null;
                if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
                    subtypeConfig = (
                        <CreateSubtypePanel
                            {...this.props}
                            input={this.props.input}
                            statePath={this.props.statePath} />
                    );
                }
                ConfigPanel = (
                    <div className="editor-panel">
                        {subtypeConfig}
                        <InputBehaviorComponent
                            {...this.props}
                            input={this.props.input}
                            statePath={this.props.statePath} />
                        {replay}
                    </div>
                );
            } else {
                ConfigPanel = (
                    <div className="editor-panel">
                        <form>
                            <fieldset>
                                <legend>Input Name</legend>
                                <ErrorModule
                                    app={this.props.app}
                                    keys={[constants.INPUT_VALIDATE]}
                                    render={(state) => {
                                        return (
                                            <FieldError field="name" errors={state.errors}/>
                                        );
                                    }}/>
                                <UncontrolledTextInput
                                    className="text-input large"
                                    defaultValue={inputName}
                                    onChange={this.props.changeHandler}
                                    data-field={this.props.statePath + ".name"}/>
                            </fieldset>
                            <InputBehaviorComponent
                                {...this.props}
                                input={this.props.input}
                                statePath={this.props.statePath} />
                            {replay}
                        </form>
                    </div>
                );
            }
        } else if (this.props.input.type == constants.INPUT_TYPE_TWITTER) {
            ConfigPanel = (
                <div>
                    <TwitterInputConfigPanel
                        {...this.props}
                        input={this.props.input}
                        changeHandler={this.props.changeHandler}
                        replayPromo={replay}
                        statePath={this.props.statePath} />
                </div>
            );
        } else if (this.props.input.type == constants.INPUT_TYPE_INSTAGRAM || this.props.input.type == constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
            ConfigPanel = (
                <div>
                    <InstagramConfigPanel
                        {...this.props}
                        input={this.props.input}
                        changeHandler={this.props.changeHandler}
                        replayPromo={replay}
                        statePath={this.props.statePath} />
                </div>
            );
        } else if (this.props.input.type == constants.INPUT_TYPE_FACEBOOK_PAGE) {
            ConfigPanel = (
                <div>
                    <FacebookPageConfigPanel
                        {...this.props}
                        input={this.props.input}
                        changeHandler={this.props.changeHandler}
                        replayPromo={replay}
                        statePath={this.props.statePath} />
                </div>
            );
        } else if (this.props.input.type == constants.INPUT_TYPE_TIKTOK) {
            ConfigPanel = (
                <div>
                    <TikTokInputConfigPanel
                        {...this.props}
                        input={this.props.input}
                        changeHandler={this.props.changeHandler}
                        replayPromo={replay}
                        statePath={this.props.statePath} />
                </div>
            );

        } else if (this.props.input.type == constants.INPUT_TYPE_YOUTUBE) {
            ConfigPanel = (
                <div>
                    <YouTubeInputConfigPanel
                        {...this.props}
                        input={this.props.input}
                        changeHandler={this.props.changeHandler}
                        replayPromo={replay}
                        statePath={this.props.statePath} />
                </div>
            );

        }


        return ConfigPanel;

    }

};

FeedConfigurePanel.displayName = "FeedConfigurePanel";

export default InputEditorWrapper(FeedConfigurePanel);
